import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=a84f476c&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a84f476c')) {
      api.createRecord('a84f476c', component.options)
    } else {
      api.reload('a84f476c', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=a84f476c&", function () {
      api.rerender('a84f476c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f0EW6PNm9von/JS/pricelisthelp.vue"
export default component.exports